<div class="avatar-dialog">
  <p-toast></p-toast>

  <input class="avatar-file-input" #fileInput type="file" accept="image/png,image/jpeg,image/webp,image/gif" (change)="onFileSelected($event)">

  <button
    class="avatar-preview-card"
    type="button"
    (click)="triggerFileInput(fileInput)"
    [disabled]="saving"
    aria-label="Seleccionar nueva foto de perfil">
    <span class="avatar-preview-wrap">
      <p-avatar
        [image]="previewUrl"
        size="xlarge"
        shape="circle"
        styleClass="avatar-preview">
      </p-avatar>
      <span class="avatar-overlay">Cambiar</span>
    </span>

    <span class="avatar-copy">
      <h3>Actualiza tu foto</h3>
      <p>Haz clic en la foto para seleccionar una imagen.</p>
    </span>
  </button>

  <div class="avatar-actions">
    <button pButton type="button" label="Guardar foto" icon="pi pi-check" (click)="save()" [disabled]="saving"></button>
  </div>

  @if (selectedFile) {
    <p class="selected-file">
      {{ selectedFile.name || 'Archivo seleccionado' }}
    </p>
  }

  <p class="avatar-help">
    Formatos permitidos: PNG, JPG, WEBP o GIF. Tamaño máximo: 5 MB.
  </p>

  <div class="avatar-footer">
    <button pButton type="button" class="p-button-text" label="Cancelar" (click)="cancel()" [disabled]="saving"></button>
  </div>
</div>
